import { useEffect } from "react";
import { useWindowStore, windowStore } from "./useWindowStore";
import { WindowFrame } from "./WindowFrame";

/**
 * Demo del WM (F0-T05, temporal — el Desktop real llega en F0-T06).
 * 4 ventanas con contenido de lectura + taskbar mínima para validar
 * minimizar/restaurar. El taskbar definitivo es parte de la shell.
 */

const DEMO_WINDOWS = [
  { id: "briefing", title: "Briefing" },
  { id: "chirp", title: "Chirp" },
  { id: "mail", title: "Mail" },
  { id: "corcho", title: "Corcho" },
] as const;

const LOREM =
  "La señora Ondina Bellamira firmó su último testamento un jueves de niebla. " +
  "El viernes apareció flotando en la dársena del club náutico. La familia dice " +
  "accidente; la aseguradora dice que primero verifiquemos. ";

export function WMDemo() {
  const windows = useWindowStore((s) => s.windows);

  useEffect(() => {
    const vp = { vw: window.innerWidth, vh: window.innerHeight };
    for (const w of DEMO_WINDOWS) windowStore.getState().open(w.id, vp);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Tab") {
        e.preventDefault();
        windowStore.getState().cycleFocus();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div style={{ position: "fixed", inset: 0, background: "var(--carbon)", overflow: "hidden" }}>
      {DEMO_WINDOWS.map(
        (w) =>
          windows[w.id] && (
            <WindowFrame key={w.id} id={w.id} title={w.title}>
              <div
                style={{
                  padding: "var(--space-4)",
                  background: "var(--papel)",
                  color: "var(--tinta)",
                  minHeight: "100%",
                  lineHeight: "var(--leading-reading)",
                }}
              >
                <p>{LOREM.repeat(6)}</p>
                <p style={{ fontFamily: "var(--font-mono)", fontSize: 13 }}>
                  2011-03-17 22:41 · REG-4471 · {w.title}
                </p>
              </div>
            </WindowFrame>
          ),
      )}

      {/* Taskbar mínima de la demo */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: 44,
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "0 12px",
          background: "var(--grafito)",
          borderTop: "1px solid var(--laton)",
          zIndex: 100000,
        }}
      >
        {DEMO_WINDOWS.map((w) => {
          const st = windows[w.id];
          return (
            <button
              key={w.id}
              type="button"
              data-testid={`task-${w.id}`}
              onClick={() => {
                const vp = { vw: window.innerWidth, vh: window.innerHeight };
                if (!st) windowStore.getState().open(w.id, vp);
                else if (st.minimized) windowStore.getState().toggleMinimize(w.id);
                else windowStore.getState().focus(w.id);
              }}
              style={{
                fontFamily: "var(--font-ui)",
                fontSize: 13,
                padding: "4px 12px",
                background: "transparent",
                color: st && !st.minimized ? "var(--papel)" : "var(--humo)",
                border: "1px solid",
                borderColor: st ? "var(--laton)" : "var(--humo)",
                borderRadius: "var(--radius-1)",
                cursor: "pointer",
              }}
            >
              {w.title}
            </button>
          );
        })}
      </div>
    </div>
  );
}
